import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import '../../../../assets/css/superadmin/dashboard/criticalalert/CriticalAlert.css';

const CriticalAlert = ({ maintenanceCost }) => {
  const costData = maintenanceCost?.trend ?? [];
  const totalMonthlyCost = maintenanceCost?.totalMonthlyCost ?? 0;
  const changePercent = maintenanceCost?.changePercent ?? 0;

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="tooltip-label">{payload[0].payload.month}</p>
          <p className="tooltip-value">Rs {payload[0].value.toLocaleString()}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="critical-alerts-container">
      <div className="alerts-header">
        <div>
          <h3 className="alerts-title">Maintenance Cost</h3>
          <p className="alerts-subtitle">Cost trends over last 6 months</p>
        </div>
      </div>

      <div className="alerts-chart-wrapper">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={costData} margin={{ top: 10, right: 10, left: 0, bottom: 10 }}>
            <defs>
              <linearGradient id="costGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#FDB714" stopOpacity={0.4} />
                <stop offset="95%" stopColor="#FDB714" stopOpacity={0.05} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#E0E0E0" vertical={false} />
            <XAxis
              dataKey="month"
              tick={{ fill: '#999999', fontFamily: 'Poppins', fontSize: 12 }}
              stroke="#E0E0E0"
              axisLine={false}
            />
            <YAxis
              tick={{ fill: '#999999', fontFamily: 'Poppins', fontSize: 12 }}
              stroke="#E0E0E0"
              axisLine={false}
              tickFormatter={(value) => `Rs ${(value / 1000).toFixed(0)}k`}
            />
            <Tooltip content={<CustomTooltip />} />
            <Area
              type="monotone"
              dataKey="cost"
              stroke="#FDB714"
              strokeWidth={3}
              fill="url(#costGradient)"
              dot={{ fill: '#FDB714', r: 5 }}
              activeDot={{ r: 7, fill: '#FDB714', stroke: '#FFFFFF', strokeWidth: 2 }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>

      <div className="alerts-summary">
        <div className="summary-item">
          <p className="summary-label">Total Monthly Cost</p>
          <h3 className="summary-value">Rs {Number(totalMonthlyCost).toLocaleString()}</h3>
        </div>
        <div className="summary-change">
          <span className={`change-badge ${changePercent <= 0 ? 'success' : ''}`}>
            {changePercent >= 0 ? '+' : ''}{changePercent}%
          </span>
          <span className="change-text">vs last month</span>
        </div>
      </div>
    </div>
  );
};

export default CriticalAlert;